<template>
<div class="chapter">
<div class="inner_page">
<h2 class="chap-acw"><a id="a25"></a>Maps</h2>
<p class="list"><a id="a26"></a><a id="page_vi"></a><span class="num">1.</span> Lower Mesopotamia</p>
<p class="list"><span class="num">2.</span> Shatt-al-Arab operations</p>
<p class="list"><a id="a31"></a><span class="num">3.</span> Fighting near Qurna</p>
<p class="list"><a id="a33"></a><span class="num">4.</span> Operations near Nasiriya</p>
<p class="list"><a id="a34"></a><span class="num">5.</span> Battle of Ctesiphon</p>
<p class="list"><a id="a36"></a><span class="num">6.</span> Plan of Kut drawn by Mousley.</p>
<p class="list"><a id="a39"></a><span class="num">7.</span> Plan of fort at Kut</p>
<p class="list"><a id="a41"></a><span class="num">8.</span> Battle of Sheikh Saad</p>
<p class="list"><a id="a43"></a><span class="num">9.</span> Battle of the Wadi</p>
<p class="list"><a id="a45"></a><span class="num">10.</span> Battle of Umm-el-Hanna</p>
<p class="list"><a id="a47"></a><span class="num">11.</span> Attack on Dujaila Redoubt</p>
<p class="list"><a id="a49"></a><span class="num">12.</span> Battle of Beit Aieesa</p>
<p class="list"><a id="a50"></a><span class="num">13.</span> Battle of Sannaiyat</p>
<p class="list"><a id="a53"></a><span class="num">14.</span> Map showing route taken by prisoners</p>
<p class="list"><a id="a55"></a><span class="num">15.</span> Battle of Mahomed Abdul Hassan</p>
<p class="list"><a id="a57"></a><span class="num">16.</span> Turkish Trench system on the Hai Salient</p>
<p class="list"><a id="a58"></a><span class="num">17.</span> Situation around Baghdad</p>
<p class="list"><a id="a61"></a><span class="num">18.</span> Northern Mesopotamia</p>
<p class="list"><a id="a62"></a><span class="num">19.</span> Battle of Jabel Hamrin</p>
<p class="list"><a id="a64"></a><span class="num">20.</span> Battle of Istabulat</p>
<p class="list"><a id="a66"></a><span class="num">21.</span> Battle of Band-I-Adhaim</p>
<p class="list"><a id="a69"></a><span class="num">22.</span> Battle of Ramadi</p>
<p class="list"><a id="a70"></a><a id="page_vii"></a><span class="num">23.</span> Battles of Daur and Tikrit</p>
<p class="list"><a id="a73"></a><span class="num">24.</span> Dunsterville’s Area of Operations</p>
<p class="list"><a id="a75"></a><span class="num">25.</span> Battle of Khan Baghdadi</p>
<p class="list"><a id="a76"></a><span class="num">26.</span> Operations leading to Tuz</p>
<p class="list"><a id="a79"></a><span class="num">27.</span> Sharqat Operations</p>
<p class="list"><a id="a81"></a><span class="num">28.</span> Battle of Sharqat</p>
<h3 class="subheading_1"><a id="ncx86"></a>Abbreviations on Maps</h3>
<table>
<tbody><tr><td class="tdright"><img alt="img2.jpg" src="images/img2.jpg"/></td>
<td>Trench lines</td></tr>
<tr><td class="tdright">Art</td>
<td>Artillery</td></tr>
<tr><td class="tdright">Cav</td>
<td>Cavalry</td></tr>
<tr><td class="tdright">CB</td>
<td>Cavalry Brigade</td></tr>
<tr><td class="tdright">CT</td>
<td>Communication Trench</td></tr>
<tr><td class="tdright">H/Huss</td>
<td>Hussars</td></tr>
<tr><td class="tdright">L</td>
<td>Lancers</td></tr>
<tr><td class="tdright">M.T.</td>
<td>Motor Transport</td></tr>
<tr><td class="tdright">OP</td>
<td>Observation Point</td></tr>
<tr><td class="tdright">VP</td>
<td>Vital Point</td></tr>
</tbody></table>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 06_Mapslist.vue?1d3fca41